import { defineStore } from 'pinia'
import { login, getUserInfo } from '@/api/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('admin_token') || '',
    isLoading: false
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
    userInfo: (state) => state.user
  },

  actions: {
    // 登录
    async login(credentials) {
      this.isLoading = true
      try {
        const response = await login(credentials)
        console.log('登录响应:', response)
        
        // 根据后端返回的实际数据结构调整
        let token, user;
        
        // 打印完整的响应数据，方便调试
        console.log('完整的响应数据:', JSON.stringify(response.data));
        
        if (response.data && (response.data.code === 200 || response.data.code === 0)) {
          // 标准响应格式
          token = response.data.data?.token;
          user = response.data.data?.user;
          
          // 根据后端实际返回格式获取 token
          if (!token && response.data.data) {
            if (typeof response.data.data === 'string') {
              // 如果 data 直接是 token 字符串
              token = response.data.data;
            } else if (response.data.data.token) {
              // 从 data.token 获取
              token = response.data.data.token;
              // 获取用户信息
              user = response.data.data.adminInfo;
            } else if (response.data.data.admin_token) {
              // 如果 token 在其他字段中
              token = response.data.data.admin_token;
            }
          }
        } else if (response.data && response.data.token) {
          // 直接返回 token 和 user
          token = response.data.token;
          user = response.data.user;
        } else if (response.data && typeof response.data === 'string') {
          // 如果直接返回了 token 字符串
          token = response.data;
        } else {
          // 尝试从整个响应中找到任何可能的 token
          const responseStr = JSON.stringify(response);
          const tokenMatch = responseStr.match(/"token":"([^"]+)"/);
          if (tokenMatch && tokenMatch[1]) {
            token = tokenMatch[1];
            console.log('从响应中提取到的 token:', token);
          } else {
            throw new Error('无效的响应格式');
          }
        }
        
        if (!token) {
          throw new Error('登录成功但未获取到令牌');
        }
        
        this.token = token;
        this.user = user || { username: 'admin' }; // 如果没有用户信息，提供默认值
        
        // 确保 token 被正确存储
        localStorage.setItem('admin_token', token);
        
        // 验证 token 是否正确存储
        const storedToken = localStorage.getItem('admin_token');
        if (!storedToken || storedToken !== token) {
          console.error('Token 存储失败:', { 
            expected: token, 
            actual: storedToken 
          });
          throw new Error('令牌存储失败');
        }
        
        // 打印存储的令牌，方便调试
        console.log('存储的令牌:', token);
        
        return { success: true };
      } catch (error) {
        console.error('登录错误:', error);
        return { 
          success: false, 
          message: error.response?.data?.message || error.message || '登录失败' 
        };
      } finally {
        this.isLoading = false;
      }
    },

    // 获取用户信息
    async getUserInfo() {
      if (!this.token) return
      
      try {
        const response = await getUserInfo()
        this.user = response.data
        return response.data
      } catch (error) {
        this.logout()
        throw error
      }
    },

    // 登出
    logout() {
      this.user = null
      this.token = ''
      localStorage.removeItem('admin_token')
    },

    // 更新用户信息
    updateUser(userData) {
      this.user = { ...this.user, ...userData }
    }
  }
})
